/* Date helpers */

/**
 * Returns date in form of YYYY-MM-DD without time or timezone offset (it is assumed that it operates in partner's timezone)
 * @param {string} date - Date as string (e.g., '2025-08-06T00:00:00+03:00')
 */
export const getYYYYMMDDFromDateTimeString = (date) => {
  return date.split('T')[0]
}

/* Other */

export const toTitleCase = (str) => {
  return str[0].toUpperCase() + str.slice(1).toLowerCase();
}